<template>
  <div class="tw-grid tw-grid-cols-2 tw-gap-4 tw-mb-3">
    <div class="tw-flex tw-items-center tw-gap-2">
      <div class="tw-text-2xl tw-font-medium">
        {{ copy.messagesTitle }}
      </div>
      <div
        v-if="numberOfReplies > 0"
        class="
          tw-flex
          tw-items-center
          tw-px-1.5
          tw-py-1.5
          tw-bg-sf-ai-subtle-1
          tw-rounded-lg
          tw-text-xs
          tw-font-medium
        "
      >
        {{ copy.addedReplies(numberOfReplies) }}
      </div>
    </div>
    <div class="tw-flex tw-items-center tw-justify-between tw-px-6">
      <div class="tw-text-2xl tw-font-medium">
        {{ copy.todosTitle }}
      </div>
      <div>
        <SfButtonDs
          variant="primary"
          size="sm"
          data-testid="add-todo-button"
          @click="handleAddTodo"
        >
          +
          {{ copy.addTodoButton }}
        </SfButtonDs>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'

const I18n = useI18n()
const copy = {
  messagesTitle: I18n.t('client_meetings.past.messages_title'),
  addedReplies: (count: number) =>
    I18n.t('client_meetings.past.meeting_proposal.added_replies', {
      count,
    }),
  todosTitle: I18n.t('client_meetings.past.todos.title'),
  addTodoButton: I18n.t('client_meetings.past.todos.add_todo_button'),
}

interface Props {
  numberOfReplies: number
}

withDefaults(defineProps<Props>(), {
  numberOfReplies: 0,
})

const emit =
  defineEmits<{
    'add-todo': []
  }>()

function handleAddTodo() {
  emit('add-todo')
}
</script>
